import React from 'react';
import StockPartOverview from './StockPartOverview';
import StockPart from './StockPart';
import HistoryUsage from './HistoryUsage';
import { getLocalAuth } from '../../utils/AuthUtils';
import ErrorNotFound from '../errors/Error';

function AnalyticReport() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter(data => {
    return data.code === "Analytic Report"
  });

  let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Read"
  });

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="card radius-15 overflow-hidden">
                  <div className="card-header border-bottom-0">
                    <div className="d-flex align-items-center">
                      <div>
                        <h5 className="mb-0">Stock All Parts Overview</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body p-0" style={{ overflowX: 'scroll' }}>
                    <StockPartOverview />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-7">
                <div className="card radius-15 overflow-hidden">
                  <div className="card-header border-bottom-0">
                    <div className="d-flex align-items-center">
                      <div>
                        <h5 className="mb-0">Stock Part</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body p-0" style={{ height: '400px', overflowY: 'scroll' }}>
                    <div className="table-responsive">
                      <StockPart />
                    </div>
                  </div>
                </div>
              </div>
              <HistoryUsage />
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default AnalyticReport